import React, { Component } from "react";
import Slider from "react-slick";
import lodgingImg1 from '../img/Wonders/lodging/Hapuku Lodge  Tree Houses 1.jpg';
import lodgingImg2 from '../img/Wonders/lodging/Lodge Postcard Shot 1 (high res JPEG) 1.jpg';
import lodgingImg3 from '../img/Wonders/lodging/thumbnail_ATTRACTIONS_HerewekaRetreat_003_DunedinNZ 2 1.jpg';
import lodgingImg4 from '../img/Wonders/lodging/WW_Lodging_4_Boho Bach 1.jpg';
import lodgingImg5 from '../img/Wonders/lodging/37-3-050a-1 1.jpg';
import lodgingImg6 from '../img/Wonders/lodging/Lodge Postcard Shot 1 (high res JPEG) 1.jpg';
import NextArrow from '../img/Arrow Right.png';
import PrevArrow from '../img/Arrow Left.png'

function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block"}}
        onClick={onClick}><img className="arrow" src={NextArrow}/></div>
    );
  }
  
  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block" }}
        onClick={onClick}><img className="arrow" src={PrevArrow}/></div>
    );
  }

export default class SimpleSlider extends Component {
    state = {
        showPrevArrow: false,
      };
      handleAfterChange = (currentSlide) => {
        // Show previous arrow after the first slide
        if (currentSlide > 0) {
          this.setState({ showPrevArrow: true });
        } else {
          this.setState({ showPrevArrow: false });
        }
      };
  render() {
    const { showPrevArrow } = this.state;
    const settings = {
        dots: true,
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        variableWidth: true,
        nextArrow: <SampleNextArrow />,
        prevArrow: showPrevArrow ? <SamplePrevArrow /> : null, // Conditionally render the SamplePrevArrow component
        responsive: [
          {
            breakpoint: 1439,
            settings: {
              slidesToShow: 3
            }
          },
            {
              breakpoint: 980,
              settings: {
                slidesToShow: 1,
                variableWidth: false,
              }
            },
        ],
        afterChange: this.handleAfterChange, // Handle slide change event
    };
    return (
      <div className="lodging-carousel">
        <Slider {...settings} className="full-width-carousel">
            <div>
                <div className="thumbnail-img pt-5">
                    <img className="full-width" src={lodgingImg1}/>
                </div>
                <div className="content pt-3 pb-5">
                    <h3 className="number violet">1</h3>
                    <h3>Hapuku Lodge + Tree Houses </h3> 
                    <p>A literal elevated lodging experience set in a manuka grove</p>
                    <p className="small-text light-italic location desktop">State Highway 1, Station Road RD 1, <br/>Kaikōura 7371, New Zealand</p>
                    <p className="small-text light-italic location mobile">State Highway 1, Station Road RD 1, <br/>Kaikōura 7371, New Zealand</p>
                    <p className="small-text light-italic location sm-desktop">State Highway 1, Station Road RD 1, Kaikōura 7371, <br/>New Zealand</p>
                </div>  
            </div> 
            <div>
                <div className="thumbnail-img pt-5">
                    <img className="full-width" src={lodgingImg2}/>
                </div>
                <div className="content pt-3 pb-5">
                    <h3 className="number violet">2</h3>
                    <h3>Milford Sound Lodge </h3> 
                    <p>Get close to nature with front-row seats to nature's wonders</p>
                    <p className="small-text light-italic location">Milford Sound / Piopiotahi, Southland 9679, <br/>New Zealand</p>
                </div>  
            </div> 
            <div>
                <div className="thumbnail-img pt-5">
                    <img className="full-width" src={lodgingImg3}/>
                    <div className="copyright white">© Hereweka Garden Retreat</div>
                </div>
                <div className="content pt-3 pb-5">
                    <h3 className="number violet">3</h3>
                    <h3>Hereweka Garden Retreat </h3> 
                    <p>Blend into nature with this self-contained, eco-friendly retreat</p>
                    <p className="small-text light-italic location">10 Hoopers Inlet Road, RD2<br/>Dunedin 9077, New Zealand</p>
                </div>  
            </div> 
            <div>
                <div className="thumbnail-img pt-5">
                    <img className="full-width" src={lodgingImg4}/>
                    <div className="copyright white">© Canopy Camping Escapes</div>
                </div>
                <div className="content pt-3 pb-5">
                    <h3 className="number violet">4</h3>
                    <h3>Boho Bach </h3> 
                    <p>Stay close to nature, and also the heart of Wellington in this 1950s bach (cottage)</p>
                    <p className="small-text light-italic location">Fortification Road, Karaka Bays, Wellington 6022, <br/>New Zealand</p>
                </div>  
            </div> 
            <div>
                <div className="thumbnail-img pt-5">
                    <img className="full-width" src={lodgingImg5}/>
                    <div className="copyright white">© Silverstream Alpaca Farmstay</div>
                </div>
                <div className="content pt-3 pb-5">
                    <h3 className="number violet">5</h3>
                    <h3>Silverstream Alpaca Farmstay </h3> 
                    <p>Share the farm with these teddy-like creatures that children will love</p>
                    <p className="small-text light-italic location">368 Moodys Road, RD 2, Kaiapoi 7692, Christchurch, <br/>North Canterbury, New Zealand</p>
                </div>  
            </div> 
            <div>
                <div className="thumbnail-img pt-5">
                    <img className="full-width" src={lodgingImg6}/>
                    <div className="copyright white">© Wilderness Lodge</div>
                </div>
                <div className="content pt-3 pb-5">
                    <h3 className="number violet">6</h3>
                    <h3>Wilderness Lodge </h3> 
                    <p>Nestled between the mountains of Arthur's Pass, with a working sheep farm at your doo</p>
                    <p className="small-text light-italic location desktop">State Highway 73, 16km East of Arthur's <br/>Pass Village, Arthur's Pass Village 7654, New Zealand</p>
                    <p className="small-text light-italic location mobile">State Highway 73, 16km East of Arthur's <br/>Pass Village, Arthur's Pass Village 7654, New Zealand</p>
                    <p className="small-text light-italic location sm-desktop">State Highway 73, 16km East of Arthur's Pass Village, Arthur's Pass Village 7654, New Zealand</p>
                </div>  
            </div> 
        </Slider>
      </div>
    );
  }
}